import { AccessRights } from 'src/app/features/role/user-role/user-role'
import { Observable, of } from 'rxjs'
import { catchError, filter, switchMap, take, timeout } from 'rxjs/operators'
import { AppState } from 'src/app/core/core.state'

import { Component, OnInit } from '@angular/core'
import { UntypedFormGroup } from '@angular/forms'
import { Store } from '@ngrx/store'

import { OperationInternalEvent } from '../operation-internal-event'
import { operationInternalEventActions } from '../operation-internal-event.actions'
import { operationInternalEventSelectors } from '../operation-internal-event.selectors'
import { NotificationService } from 'src/app/core/notification.service'
import { Actions, ofType } from '@ngrx/effects'

@Component({
  selector: 'operation-internal-event-general-tab',
  templateUrl: './show.component.html',
  styleUrls: ['./show.component.scss']
})
export class OperationInternalEventGeneralTabComponent implements OnInit {
  public operationInternalEvent$: Observable<OperationInternalEvent>
  public operationInternalEventId$: Observable<number>
  public form: UntypedFormGroup
  public accessRights = AccessRights

  constructor(
    private actions$: Actions,
    private notificationService: NotificationService,
    private store: Store<AppState>
  ) {}

  ngOnInit() {
    this.operationInternalEventId$ = this.store
      .select(operationInternalEventSelectors.selectIdRouteParam)
      .pipe(filter((id) => Boolean(id)))

    this.operationInternalEvent$ = this.operationInternalEventId$.pipe(
      switchMap((operationInternalEventId) =>
        this.store.select(
          operationInternalEventSelectors.selectById,
          operationInternalEventId
        )
      )
    )
  }

  public onSubmit(form): void {
    delete form?.value
    delete form?.fromField
    delete form?.toField
    this.operationInternalEventId$
      .pipe(take(1))
      .subscribe((operationInternalEventId) =>
        this.store.dispatch(
          operationInternalEventActions.updateOneById({
            id: operationInternalEventId,
            params: {
              ...form,
              id: parseInt(operationInternalEventId.toString())
            }
          })
        )
      )
    this.actions$
      .pipe(
        ofType(operationInternalEventActions.upsertMany),
        take(1),
        timeout(1000),
        catchError((error) => of(null))
      )
      .subscribe((action) =>
        action
          ? this.notificationService.emit('alerts.success', 'success')
          : null
      )
  }
}
